module.exports = __webpack_public_path__ + "media/images/game_icon/en/VGBACCARAT-1dce100ce4a60b9bd3e5d29e56657b65.png";